import { cn } from '@/lib/utils';
import type { ProjectStatus, ReportStatus, FieldReportStatus } from '@/shared/api/types';

const LABELS: Record<string, string> = {
  DRAFT: 'Entwurf',
  SUBMITTED: 'Eingegangen',
  TRANSCRIBING: 'Transkription',
  AI_PROCESSING: 'KI-Verarbeitung',
  REVIEW_REQUIRED: 'Prüfung nötig',
  GENERATED: 'KI-Entwurf',
  READY_TO_SEND: 'Bereit',
  AWAITING_CUSTOMER: 'Wartet auf Kunde',
  CUSTOMER_CONFIRMED: 'Bestätigt',
  CUSTOMER_REJECTED: 'Abgelehnt',
  APPROVED: 'Geprüft',
  REJECTED: 'Abgelehnt',
  CLOSED: 'Abgeschlossen',
  PENDING: 'Offen',
  CONFIRMED: 'Bestätigt',
};

const TONE: Record<string, string> = {
  DRAFT: 'bg-slate-100 text-slate-600',
  SUBMITTED: 'bg-blue-100 text-blue-700',
  TRANSCRIBING: 'bg-blue-100 text-blue-700',
  AI_PROCESSING: 'bg-blue-100 text-blue-700',
  REVIEW_REQUIRED: 'bg-amber-100 text-amber-700',
  GENERATED: 'bg-amber-100 text-amber-700',
  READY_TO_SEND: 'bg-indigo-100 text-indigo-700',
  AWAITING_CUSTOMER: 'bg-purple-100 text-purple-700',
  CUSTOMER_CONFIRMED: 'bg-green-100 text-green-700',
  CONFIRMED: 'bg-green-100 text-green-700',
  APPROVED: 'bg-green-100 text-green-700',
  CUSTOMER_REJECTED: 'bg-red-100 text-red-700',
  REJECTED: 'bg-red-100 text-red-700',
  CLOSED: 'bg-slate-200 text-slate-600',
  PENDING: 'bg-amber-100 text-amber-700',
};

export function StatusBadge({
  status,
}: {
  status: ProjectStatus | ReportStatus | FieldReportStatus | string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONE[status] ?? 'bg-slate-100 text-slate-600',
      )}
    >
      {LABELS[status] ?? status}
    </span>
  );
}
